module.exports = __webpack_public_path__ + "static/img/4272_phase_function_Paper_PointsHejduk_Prediction.7fe119e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4272_phase_function_Paper_PointsHejduk_Prediction.png
// module id = kS7y
// module chunks = 0